// extracted by mini-css-extract-plugin
export default {"noResultsContainer":"StudyResultsDashboard_noResultsContainer__J4e4k","spinnerContainer":"StudyResultsDashboard_spinnerContainer__heEJA"};